import { style } from '@vanilla-extract/css';
import { DefaultReset, color, config } from 'folds';

export const ImageEditor = style([
  DefaultReset,
  {
    height: '100%',
  },
]);

export const ImageEditorHeader = style([
  DefaultReset,
  {
    paddingLeft: config.space.S200,
    paddingRight: config.space.S200,
    borderBottomWidth: config.borderWidth.B300,
    flexShrink: 0,
    gap: config.space.S200,
  },
]);

export const ImageEditorContent = style([
  DefaultReset,
  {
    backgroundColor: color.Background.Container,
    color: color.Background.OnContainer,
    overflow: 'hidden',
  },
]);

export const Image = style({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});
